import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
  Grid,
  TextField,
  IconButton,
  Button,
  Divider,
  Chip,
  Stack,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AddIcon from "@mui/icons-material/Add";
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useSelector } from "react-redux";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import VerifiedIcon from "@mui/icons-material/Verified";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import dayjs from "dayjs";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { Link } from "react-router-dom";
import BottomNavigationBar from "../navbar/BottomNavigationBar";
import StatusDialog from "../service/dialog/list/StatusDialog";
import TanggalDialog from "../service/dialog/list/TanggalDialog";
import SummaryServiceDialog from "../service/dialog/list/SummaryServiceDialog";
import AddServiceDialog from "../service/dialog/add/AddServiceDialog";
import { sortBy } from "lodash-es";

const ServicesList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const currentUserId = useSelector((state) => state.user.currentUserId);
  const user = useSelector(
    (state) => state.user.users[state.user.currentUserId]
  );

  const [dataService, setDataService] = useState([]);

  const [openStatus, setOpenStatus] = useState(false);

  const [openTanggal, setOpenTanggal] = useState(false);

  const [openSummaryService, setOpenSummaryService] = useState(false);

  const [openAddService, setOpenAddService] = useState(false);

  const [selectedSummaryData, setSelectedSummaryData] = useState(null);


  const [selectedsalesOrderConstraintList
    , setSelectedsalesOrderConstraintList
  ] = useState(null);

  const [selectedsalesOrderDownPaymentList
    , setSelectedsalesOrderDownPaymentList
  ] = useState(null);

  const [selectedsalesOrderPartList
    , setSelectedsalesOrderPartList
  ] = useState(null);

  const [selectedsalesOrderServiceTypeList
    , setSelectedsalesOrderServiceTypeList
  ] = useState(null);

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const handleOpenStatus = () => {
    setOpenStatus(true);
  };
  const handleCloseStatus = () => {
    setOpenStatus(false);
  };

  const handleOpenTanggal = () => {
    setOpenTanggal(true);
  };
  const handleCloseTanggal = () => {
    setOpenTanggal(false);
  };

  // const handleOpenSummaryService = (id) => {
  //   const selectedData = dataService.find((item) => item.id === id);
  //   if (selectedData) {
  //     setSelectedSummaryData(selectedData);
  //     setOpenSummaryService(true);
  //   }
  // };

  const handleOpenSummaryService = async (id) => {
    try {
      const response = await axios.post(
        endpoint.Service.ServiceDetail,
        { id: id },
        {
          headers: {
            Authorization: `${user.token_type} ${user.token}`,
          },
        }
      );
      if (response.data != null) {
        setSelectedSummaryData(response.data?.data?.salesOrder);
        setSelectedsalesOrderConstraintList(response.data?.data?.salesOrderConstraintList
        );
        setSelectedsalesOrderDownPaymentList(response.data?.data?.salesOrderDownPaymentList);
        setSelectedsalesOrderPartList(response.data?.data?.salesOrderPartList);
        setSelectedsalesOrderServiceTypeList(response.data?.data?.salesOrderServiceTypeList);
        setOpenSummaryService(true);
      }
    } catch (error) {
      console.error("Gagal mengambil detail service:", error);
    }
  };

  const handleCloseSummaryService = () => {
    setOpenSummaryService(false);
  };

  const handleOpenAddService = () => {
    setOpenAddService(true);
  };

  const handleCloseAddService = () => {
    setOpenAddService(false);
  };

  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");

  // Fungsi untuk toggle visibility TextField
  // const toggleSearch = () => {
  //   setShowSearch(!showSearch);
  //   setSearchText("");
  // };

  // Fungsi untuk mengubah nilai pencarian
  const handleSearchChange = (event) => setSearchText(event.target.value);

  // const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({
    value: null,
    label: "",
  });
  const [selectedTanggal, setSelectedTanggal] = useState(null);

  const handleStatusSelect = (value, label) => {
    setSelectedStatus({ value, label });
    setOpenStatus(false);
  };

  const handleTanggalSelect = (value) => {
    setSelectedTanggal(value);
    setOpenTanggal(false);
  };

  const handleClearStatus = () => {
    setSelectedStatus({ value: null, label: "" });
  };

  const handleClearTanggal = () => {
    setSelectedTanggal(null);
    setDateRange({ start: null, end: null });
  };

  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  // const startDateValue = dateRange?.start || selectedTanggal;

  // const endDateValue = dateRange?.end || selectedTanggal;

  // const getData = async () => {
  //   try {
  //     if (user?.token) {

  //       const response = await axios.post(
  //         endpoint.Service.ServiceList,
  //         { status: selectedStatus,
  //           search: searchText,
  //           starDate: startDateValue,
  //           endDate: endDateValue,
  //           page: currentPage,
  //           pageSize: pageSize,
  //          },
  //         {
  //           headers: {
  //             Authorization: `${user.token_type} ${user.token}`,
  //           },
  //         }
  //       );

  //       const data = response.data.data?.data;
  //       setDataService(data || []);

  //       setTotal(response.data.total);
  //     }
  //   } catch (error) {
  //     console.error("Data gagal dieksekusi", error);
  //   }
  // };

  // useEffect(() => {
  //   getData();
  // }, [selectedStatus, searchText, selectedTanggal, dateRange, currentPage, pageSize]);

  // Filter data untuk menentuakan kecepatan load
  const filters = useMemo(
    () => ({
      status: selectedStatus.value,
      search: searchText,
      startDate: dateRange.start || selectedTanggal,
      endDate: dateRange.end || selectedTanggal,
      page: currentPage,
      pageSize: pageSize,
    }),
    [
      selectedStatus,
      searchText,
      dateRange,
      selectedTanggal,
      currentPage,
      pageSize,
    ]
  );

  // Debounce getData calls
  const getData = useCallback(async () => {
    if (!user?.token) return;
    try {
      const response = await axios.post(endpoint.Service.ServiceList, filters, {
        headers: { Authorization: `${user.token_type} ${user.token}` },
      });
      setDataService(response.data.data?.data || []);
      setTotal(response.data.total);
    } catch (err) {
      console.error("Failed to fetch services", err);
    }
  }, [filters, user]);

  useEffect(() => {
    const handler = setTimeout(() => getData(), 100);
    return () => clearTimeout(handler);
  }, [getData]);

  // Handlers
  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
    setSearchText("");
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        {/* Icon untuk menampilkan dan menyembunyikan TextField */}
        <IconButton
          sx={{
            position: "absolute",
            top: -10,
            right: 20,
            width: 30,
            height: 30,
            backgroundColor: "success.light",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20,
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            cursor: "pointer",
          }}
          onClick={toggleSearch}
        >
          <SearchIcon sx={{ color: "white" }} />
        </IconButton>

        <Typography
          variant={isMobile ? "p" : "h6"}
          sx={{
            fontWeight: "bold",
            fontFamily: '"Arial", Times, serif',
            color: "white",
            textShadow: "0 0 6px rgba(0,0,0,0.5)",
          }}
        >
          Service
        </Typography>

        {/* Menampilkan TextField jika showSearch true */}
        {showSearch && (
          <Paper
            elevation={3}
            sx={{ p: 2, mt: 2, display: "flex", alignItems: "center" }}
          >
            <TextField
              label="Cari service"
              autoComplete="Off"
              value={searchText}
              onChange={handleSearchChange}
              variant="outlined"
              fullWidth
              sx={{ mr: 2 }}
            />
            {/* Tombol untuk menyembunyikan TextField */}
            <IconButton onClick={toggleSearch}>
              <Typography variant="body1" color="primary">
                <CloseIcon />
              </Typography>
            </IconButton>
          </Paper>
        )}
      </Box>

      <Box
        sx={{
          minHeight: "5vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 2 : 4,
        }}
      ></Box>
      <Box sx={{ mt: -2 }}>
        <Paper
          elevation={3}
          sx={{ p: 2, backgroundColor: "rgba(255, 255, 255, 0.9)" }}
        >
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.1,
                  mb: 2,
                }}
              >
                {/* Clear Status Button di kiri */}
                {selectedStatus.value != null && selectedStatus.label != "" ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "#e0e0e0",
                      borderRadius: "50%",
                      cursor: "pointer",
                      height: 16,
                      width: 16,
                      marginRight: 0,
                    }}
                    onClick={handleClearStatus}
                  >
                    <CloseIcon fontSize="small" />
                  </Box>
                ) : (
                  <Box sx={{ width: 16 }} />
                )}

                {/* Filter Status */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f5f5f5",
                    p: 0.8,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={handleOpenStatus}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    display="block"
                    sx={{ mr: 0.5 }}
                  >
                    {selectedStatus?.label != ""
                      ? selectedStatus?.label
                      : "Status"}
                  </Typography>
                  <ArrowForwardIosIcon
                    sx={{ fontSize: 12, color: "text.secondary" }}
                  />
                </Box>

                {/* Clear Tanggal Button di kanan */}
                {selectedTanggal || (dateRange?.start && dateRange?.end) ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "#e0e0e0",
                      borderRadius: "50%",
                      cursor: "pointer",
                      height: 20,
                      width: 20,
                      ml: "-4px", // lebih dekat dengan box tanggal
                    }}
                    onClick={handleClearTanggal}
                  >
                    <CloseIcon sx={{ fontSize: 12 }} />
                  </Box>
                ) : (
                  <Box sx={{ width: 20 }} /> // agar tata letak tetap rata
                )}

                {/* Filter Tanggal */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "#f5f5f5",
                    p: 0.8,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={handleOpenTanggal}
                >
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    display="block"
                    sx={{ mr: 0.5 }}
                  >
                    {selectedTanggal != null
                      ? selectedTanggal
                      : dateRange.start != null && dateRange.end != ""
                      ? `${dateRange.start} - ${dateRange.end}`
                      : "Tanggal"}
                  </Typography>
                  <ArrowForwardIosIcon
                    sx={{ fontSize: 12, color: "text.secondary" }}
                  />
                </Box>
              </Box>

              {dataService.length === 0 ? (
                <Box
                  sx={{
                    p: 4,
                    borderRadius: 3,
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    textAlign: "center",
                    border: "1px dashed #ccc",
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    Tidak ada data service yang tersedia.
                  </Typography>
                </Box>
              ) : (
                dataService.map((item, index) => (
                  <Paper
                    key={item.id}
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 3,
                      cursor: "pointer",
                    }}
                    onClick={() => handleOpenSummaryService(item.id)}
                  >
                    <Box display="flex" flexDirection="column" gap={4}>
                      {/* Baris Pertama */}
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          flexWrap="wrap"
                        >
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#651fff",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              mt: 0.2,
                              mr: 1,
                            }}
                          >
                            <ArrowDownwardIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                            display="block"
                          >
                            {item.device_name ? item.device_name : ""}
                          </Typography>
                        </Box>
                      </Box>
                      <Divider />

                      {/* Baris Kedua */}
                      <Box display="flex" alignItems="center" gap={3}>
                        {item?.status == 1 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#4caf50", // hijau
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CheckCircleRoundedIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        ) : item?.status == 2 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#ff9800", // oranye
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <HourglassEmptyIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        ) : item?.status == 3 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#2196f3", // biru
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <DoneAllIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        ) : item?.status == 4 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#3f51b5", // biru gelap
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <MonetizationOnIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        ) : item?.status == 5 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#9c27b0", // ungu
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <VerifiedIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        ) : item?.status == 6 ? (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#f44336", // merah
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <CloseIcon sx={{ color: "white", fontSize: 20 }} />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              width: 30,
                              height: 30,
                              bgcolor: "#9e9e9e", // abu
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <HelpOutlineIcon
                              sx={{ color: "white", fontSize: 20 }}
                            />
                          </Box>
                        )}
                        <Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            display="block"
                          >
                            {item?.status == 1
                              ? "Diterima"
                              : item?.status == 2
                              ? "Diproses"
                              : item?.status == 3
                              ? "Selesai"
                              : item?.status == 4
                              ? "Dibayar"
                              : item?.status == 5
                              ? "Diklaim"
                              : item?.status == 6
                              ? "Dibatalkan"
                              : "-"}{" "}
                            {item?.status != "" ? "Pada" : "-"}
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                            display="block"
                          >
                            {dayjs(item.date).format("DD MMM YYYY HH.mm")
                              ? dayjs(item.date).format("DD MMM YYYY HH.mm")
                              : "-"}
                          </Typography>
                        </Box>
                        <Box>
                          <Button
                            variant="contained"
                            color={
                              item?.status == 1
                                ? "primary"
                                : item?.status == 2
                                ? "warning"
                                : item?.status == 3
                                ? "success"
                                : item?.status == 4
                                ? "primary"
                                : item?.status == 5
                                ? "success"
                                : item?.status == 6
                                ? "error"
                                : "-"
                            }
                            sx={{
                              minWidth: 70,
                              height: 35,
                              borderRadius: "45%",
                              padding: 0,
                              fontSize: 12,
                              textTransform: "none",
                            }}
                          >
                            {item?.status == 1
                              ? "Diterima"
                              : item?.status == 2
                              ? "Diproses"
                              : item?.status == 3
                              ? "Selesai"
                              : item?.status == 4
                              ? "Dibayar"
                              : item?.status == 5
                              ? "Diklaim"
                              : item?.status == 6
                              ? "Dibatalkan"
                              : "-"}
                          </Button>
                        </Box>
                      </Box>

                      {/* Baris Ketiga */}
                      <Box display="flex" alignItems="center" gap={10}>
                        <Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            display="block"
                          >
                            Pelanggan
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                            display="block"
                          >
                            {item.customer_name ? item.customer_name : "-"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            display="block"
                          >
                            Estimasi Biaya
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                            display="block"
                          >
                            {new Intl.NumberFormat("id-ID", {
                              style: "currency",
                              currency: "IDR",
                            }).format(item.total)
                              ? new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                }).format(item.total)
                              : "-"}
                          </Typography>
                        </Box>
                      </Box>

                      {item?.status == 6 && (
                        <>
                          {/* Alasan Pembatalan */}
                          <Box display="flex" alignItems="center" gap={2}>
                            <Box>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                display="block"
                              >
                                Alasan Pembatalan
                              </Typography>
                            </Box>
                            <Box
                              display="flex"
                              alignItems="flex-start"
                              flexWrap="wrap"
                            >
                              <CheckCircleRoundedIcon
                                sx={{
                                  color: "success.main",
                                  fontSize: 20,
                                  mt: 0.1,
                                  mr: 0.5,
                                }}
                              />
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                color="text.primary"
                                display="block"
                              >
                                {user?.name ? user?.name : "-"}
                              </Typography>
                            </Box>
                          </Box>

                          {/* Baris Kelima */}
                          <Box display="flex" alignItems="center" gap={1}>
                            <Box
                              sx={{
                                width: "100%",
                                bgcolor: "#e0e0e0",
                                pointerEvents: "none",
                                p: 2,
                                borderRadius: 3,
                              }}
                            >
                              <Typography
                                variant="body2"
                                color="#000"
                                display="block"
                              >
                                {item.status_order ? item.status_order : "-"}
                              </Typography>
                            </Box>
                          </Box>

                          <Divider />
                        </>
                      )}

                      {/* Baris Keenam */}
                      <Box display="flex" alignItems="center" gap={1}>
                        <Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            display="block"
                          >
                            Daftar Kendala
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="text.primary"
                            display="block"
                          >
                            {Array.isArray(item.kendala_items) &&
                            item.kendala_items.length > 0 ? (
                              <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                              >
                                {item.kendala_items.map((kendala, index) => (
                                  <Chip
                                    key={index}
                                    label={kendala}
                                    size="small"
                                  />
                                ))}
                              </Stack>
                            ) : (
                              <span>-</span>
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                ))
              )}
            </Grid>
          </Grid>
        </Paper>
      </Box>

      {!openStatus &&
        !openTanggal &&
        !openSummaryService &&
        !openAddService && (
          <IconButton
            color="primary"
            sx={{
              position: "fixed",
              bottom: 80,
              right: 20,
              bgcolor: "#1976d2",
              color: "#fff",
              width: 56,
              height: 56,
              borderRadius: "50%",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
              zIndex: 2000,
              ":hover": {
                bgcolor: "#115293",
              },
            }}
            onClick={handleOpenAddService}
          >
            <AddIcon />
          </IconButton>
        )}

      <StatusDialog
        openStatus={openStatus}
        onSelect={handleStatusSelect}
        handleCloseStatus={handleCloseStatus}
      />

      <TanggalDialog
        openTanggal={openTanggal}
        onDateRangeChange={handleDateRangeChange}
        onDateSelect={handleTanggalSelect}
        handleCloseTanggal={handleCloseTanggal}
      />

      <SummaryServiceDialog
        data={selectedSummaryData}
        dataConstraintList={selectedsalesOrderConstraintList}
        dataDownPaymentList={selectedsalesOrderDownPaymentList}
        dataPartList={selectedsalesOrderPartList}
        dataServiceTypeList={selectedsalesOrderServiceTypeList}
        openSummaryService={openSummaryService}
        handleCloseSummaryService={handleCloseSummaryService}
      />

      <AddServiceDialog
        redirect={getData}
        openAddService={openAddService}
        handleCloseAddService={handleCloseAddService}
      />

      <BottomNavigationBar />
    </>
  );
};

export default ServicesList;
